export default "549b6992bd68c9b8.svg"